import { c as _c } from "react/compiler-runtime";
import type { RiskSignal } from '@onefootprint/request-types/dashboard';
import { Drawer, SearchInput } from '@onefootprint/ui';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useRiskSignalsSpec from '@/hooks/use-risk-signals-spec';
import CategoryToggle from './components/category-toggle';
import { ReasonCodeCard } from './components/reason-code-card';
import SubcategoryToggle from './components/subcategory-toggle';
type RiskSignalsGlossaryProps = {
  open: boolean;
  onClose: () => void;
};
type RiskSignalCategory = {
  name: string;
  subCategories: Array<{
    name: string;
    reasonCodes: Array<RiskSignal>;
  }>;
};
type RiskSignalGroup = {
  category: Array<RiskSignalCategory>;
};
const RiskSignalsGlossary = t0 => {
  const $ = _c(51);
  const {
    open,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.riskSignalsGlossary"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  const riskSignalsQuery = useRiskSignalsSpec();
  const [showSubCategory, setShowSubCategory] = useState(null);
  const [showReasonCodes, setShowReasonCodes] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef(null);
  let t2;
  if ($[1] !== onClose) {
    t2 = () => onClose();
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClose = t2;
  let t3;
  if ($[3] !== handleClose) {
    t3 = e => {
      if (e.key === "Escape") {
        handleClose();
      }
    };
    $[3] = handleClose;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleKeyDown = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (e_0, categoryName) => {
      if (e_0.key === "Enter" || e_0.key === " ") {
        e_0.preventDefault();
        setShowSubCategory(prev => prev === categoryName ? null : categoryName);
        setShowReasonCodes(null);
      }
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleCategoryKeyDown = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = (e_1, subCategoryName) => {
      if (e_1.key === "Enter" || e_1.key === " ") {
        e_1.preventDefault();
        setShowReasonCodes(prev_0 => prev_0 === subCategoryName ? null : subCategoryName);
      }
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleSubcategoryKeyDown = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = categoryName_0 => {
      setShowSubCategory(prev_1 => prev_1 === categoryName_0 ? null : categoryName_0);
      setShowReasonCodes(null);
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handleCategoryToggle = t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = subCategoryName_0 => {
      setShowReasonCodes(prev_2 => prev_2 === subCategoryName_0 ? null : subCategoryName_0);
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleSubcategoryToggle = t7;
  if (riskSignalsQuery.isPending || !riskSignalsQuery.data) {
    return null;
  }
  const data = riskSignalsQuery.data as unknown as Record<string, RiskSignalGroup>;
  let t8;
  if ($[9] !== data || $[10] !== searchTerm) {
    const allReasonCodes = Object.values(data).flatMap(_temp3);
    const searchLowerCase = searchTerm.toLowerCase();
    t8 = searchTerm ? allReasonCodes.filter(reason => reason.reasonCode.toLowerCase().includes(searchLowerCase) || reason.note.toLowerCase().includes(searchLowerCase) || reason.description.toLowerCase().includes(searchLowerCase)) : [];
    $[9] = data;
    $[10] = searchTerm;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const filteredReasonCodes = t8;
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t9;
  if ($[12] !== data || $[13] !== filteredReasonCodes || $[14] !== handleClose || $[15] !== handleKeyDown || $[16] !== open || $[17] !== searchTerm || $[18] !== showReasonCodes || $[19] !== showSubCategory || $[20] !== t) {
    const groupedCategories = searchTerm ? {} : Object.entries(data).reduce(_temp6, {} as Record<string, Record<string, Record<string, RiskSignal[]>>>);
    T0 = Drawer;
    t13 = open;
    if ($[30] !== t) {
      t14 = t(_temp7);
      $[30] = t;
      $[31] = t14;
    } else {
      t14 = $[31];
    }
    t15 = handleClose;
    let t17;
    if ($[32] !== t) {
      t17 = t(_temp8);
      $[32] = t;
      $[33] = t17;
    } else {
      t17 = $[33];
    }
    let t18;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = e_2 => setSearchTerm(e_2.target.value);
      $[34] = t18;
    } else {
      t18 = $[34];
    }
    let t19;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = () => setSearchTerm("");
      $[35] = t19;
    } else {
      t19 = $[35];
    }
    if ($[36] !== searchTerm || $[37] !== t17) {
      t16 = <div className="pb-3"><SearchInput ref={searchInputRef} placeholder={t17} onChange={t18} value={searchTerm} onReset={t19} /></div>;
      $[36] = searchTerm;
      $[37] = t17;
      $[38] = t16;
    } else {
      t16 = $[38];
    }
    t9 = "flex flex-col gap-3";
    t10 = handleKeyDown;
    t11 = "tree";
    t12 = searchTerm ? filteredReasonCodes.map(_temp9) : Object.entries(groupedCategories).map(t20 => {
      const [groupName_0, categories] = t20;
      return <div key={groupName_0} className="flex flex-col overflow-hidden border rounded-md border-tertiary"><div className="flex items-center gap-2 px-3 py-2 border-b border-tertiary bg-secondary"><h2 className="uppercase text-caption-1">{groupName_0}</h2></div><div className="flex flex-col py-2">{Object.entries(categories).map(t21 => {
            const [categoryName_2, subCategories_1] = t21;
            const subCategoriesCount = Object.keys(subCategories_1).length;
            const allReasonCodes_0 = Object.values(subCategories_1).flat();
            return <div key={categoryName_2} className="flex flex-col px-2" role="treeitem" aria-expanded={showSubCategory === categoryName_2}><CategoryToggle categoryName={categoryName_2} onClick={() => handleCategoryToggle(categoryName_2)} onKeyDown={e_3 => handleCategoryKeyDown(e_3, categoryName_2)} isActive={showSubCategory === categoryName_2} tabIndex={0} />{showSubCategory === categoryName_2 && <div className="pl-4 mt-1">{subCategoriesCount === 1 ? <li className="relative flex flex-col gap-1 mb-1">{allReasonCodes_0.map(_temp10)}</li> : Object.entries(subCategories_1).map(t22 => {
                  const [subCategoryName_1, reasonCodes_1] = t22;
                  return <div key={subCategoryName_1} className="relative flex flex-col" role="treeitem" aria-expanded={showReasonCodes === subCategoryName_1}><SubcategoryToggle subCategoryName={subCategoryName_1} onClick={() => handleSubcategoryToggle(subCategoryName_1)} onKeyDown={e_4 => handleSubcategoryKeyDown(e_4, subCategoryName_1)} isActive={showReasonCodes === subCategoryName_1} tabIndex={0} />{showReasonCodes === subCategoryName_1 && <ul className="pl-4 mt-1">{reasonCodes_1.map(_temp11)}</ul>}</div>;
                })}</div>}</div>;
          })}</div></div>;
    });
    $[12] = data;
    $[13] = filteredReasonCodes;
    $[14] = handleClose;
    $[15] = handleKeyDown;
    $[16] = open;
    $[17] = searchTerm;
    $[18] = showReasonCodes;
    $[19] = showSubCategory;
    $[20] = t;
    $[21] = T0;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
    $[29] = t9;
  } else {
    T0 = $[21];
    t10 = $[22];
    t11 = $[23];
    t12 = $[24];
    t13 = $[25];
    t14 = $[26];
    t15 = $[27];
    t16 = $[28];
    t9 = $[29];
  }
  let t17;
  if ($[39] !== t10 || $[40] !== t11 || $[41] !== t12 || $[42] !== t9) {
    t17 = <div className={t9} onKeyDown={t10} role={t11}>{t12}</div>;
    $[39] = t10;
    $[40] = t11;
    $[41] = t12;
    $[42] = t9;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== T0 || $[45] !== t13 || $[46] !== t14 || $[47] !== t15 || $[48] !== t16 || $[49] !== t17) {
    t18 = <T0 open={t13} title={t14} onClose={t15}>{t16}{t17}</T0>;
    $[44] = T0;
    $[45] = t13;
    $[46] = t14;
    $[47] = t15;
    $[48] = t16;
    $[49] = t17;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  return t18;
};
export default RiskSignalsGlossary;
function _temp(t0) {
  const {
    reasonCodes
  } = t0;
  return reasonCodes;
}
function _temp2(t0) {
  const {
    subCategories
  } = t0;
  return subCategories.flatMap(_temp);
}
function _temp3(t0) {
  const {
    category
  } = t0;
  return category.flatMap(_temp2);
}
function _temp4(subAcc, t0) {
  const {
    name: subName,
    reasonCodes: reasonCodes_0
  } = t0;
  if (reasonCodes_0.length > 0) {
    subAcc[subName] = [...(subAcc[subName] || []), ...reasonCodes_0];
  }
  return subAcc;
}
function _temp5(categoryAcc, t0) {
  const {
    name: categoryName_1,
    subCategories: subCategories_0
  } = t0;
  categoryAcc[categoryName_1] = subCategories_0.reduce(_temp4, categoryAcc[categoryName_1] || {});
  if (Object.keys(categoryAcc[categoryName_1]).length === 0) {
    delete categoryAcc[categoryName_1];
  }
  return categoryAcc;
}
function _temp6(acc, t0) {
  const [groupName, t1] = t0;
  const {
    category: category_0
  } = t1;
  acc[groupName] = category_0.reduce(_temp5, {} as Record<string, Record<string, RiskSignal[]>>);
  return acc;
}
function _temp7($) {
  return $.title;
}
function _temp8($_0) {
  return $_0.searchPlaceholder;
}
function _temp9(reason_0) {
  return <ReasonCodeCard key={reason_0.id} reason={reason_0} hasSubcategory={false} />;
}
function _temp10(reason_1) {
  return <ReasonCodeCard key={reason_1.id} reason={reason_1} hasSubcategory={false} tabIndex={0} />;
}
function _temp11(reason_2) {
  return <ReasonCodeCard key={reason_2.id} reason={reason_2} hasSubcategory={true} tabIndex={0} />;
}